import storeManager from '../../store/StoreManager';
import utilService from '../UtilService';
import liveSessionMessageHandler from '../AWSIOTMessageHandler/LiveSessionMessageHandler';
import livestreamActions from '../../actions/LivestreamActions';
import p2pConnectionStore from '../livesession/P2PConnectionStore';
import liveSessionService from '../livesession/LiveSessionService';

const { liveSessionMessageType } = livestreamActions;

const liveSessionHandler = {
    handleLiveSessionChange(liveSessionState) {
        const p2pLiveSessions = liveSessionState?.p2pLiveSessions;

        if (!p2pLiveSessions) {
            return;
        }

        p2pLiveSessions.forEach((liveSession) => {
            const {
                proctorOffer,
                proctorIceCandidates,
                proctoringMode,
            } = liveSession;


            if (proctoringMode) {
                if (proctorOffer) {
                    this.handleOfferReceived(liveSession);
                }

                this.handleProctoringModeReceived(liveSession);
            }

            if (proctorIceCandidates) {
                this.handleProctorIceCandidatesReceived(liveSession);
            }
        });
    },

    areIceCandidatesUpdated(assessmentRunSessionContributorId, liveSessionTimestamp, iceCandidates) {
        const currentIceCandidates = p2pConnectionStore.getRemoteIceCandidates(assessmentRunSessionContributorId, liveSessionTimestamp);
        return !utilService.isDeepEqual(currentIceCandidates, iceCandidates);
    },

    handleProctorIceCandidatesReceived(liveSession) {
        const { assessmentRunSessionContributorId, liveSessionTimestamp, proctorIceCandidates } = liveSession;
        if (!!proctorIceCandidates?.length
                && this.areIceCandidatesUpdated(assessmentRunSessionContributorId, liveSessionTimestamp, proctorIceCandidates)) {
            p2pConnectionStore.resetRemoteIceCandidates(assessmentRunSessionContributorId, liveSessionTimestamp);
            const data = {
                messageType: liveSessionMessageType.ICE_CANDIDATES,
                messagerId: assessmentRunSessionContributorId,
                iceCandidates: proctorIceCandidates,
                liveSessionTimestamp,
            };
            liveSessionMessageHandler.handleOfferOrIceCandidatesMessage(data);
        }
    },

    isLiveSessionOfferUpdated(messagerId, liveSessionTimestamp, offer) {
        const currentOffer = p2pConnectionStore.getP2POffer(messagerId, liveSessionTimestamp);
        return !utilService.isDeepEqual(currentOffer, offer);
    },

    handleOfferReceived(liveSession) {
        const {
            assessmentRunSessionContributorId,
            audioExpectation,
            liveSessionTimestamp,
            proctoringMode,
            proctorOffer,
            videoExpectation,
        } = liveSession;

        if (this.isLiveSessionOfferUpdated(assessmentRunSessionContributorId, liveSessionTimestamp, proctorOffer)) {
            const data = {
                messageType: liveSessionMessageType.OFFER,
                messagerId: assessmentRunSessionContributorId,
                messageDescription: proctorOffer,
                proctoringMode,
                liveSessionTimestamp,
                videoExpectation,
                audioExpectation,
            };
            liveSessionMessageHandler.handleOfferOrIceCandidatesMessage(data);
        }
    },

    isProctoringModeUpdated(callId, proctoringMode) {
        const { livestream } = storeManager.getState();
        const registeredCall = liveSessionService.getRegisteredCall(livestream, callId);

        return registeredCall?.proctoringMode !== proctoringMode;
    },

    handleProctoringModeReceived(liveSession) {
        const { assessmentRunSessionContributorId, proctoringMode } = liveSession;

        if (this.isProctoringModeUpdated(assessmentRunSessionContributorId, proctoringMode)) {
            const data = {
                messageType: liveSessionMessageType.PROCTORING_MODE_UPDATED,
                messagerId: assessmentRunSessionContributorId,
                proctoringMode,
            };
            liveSessionMessageHandler.handleProctoringModeUpdatedMessage(data);
        }
    },
};

export default liveSessionHandler;
